// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main.btn.facebook[data-v-25814009]:hover{color:var(--color-white);background-color:var(--color-dark-facebook)}.main.btn.facebook[data-v-25814009]{background-color:var(--color-facebook);font-weight:600}.main.btn.facebook .btnText[data-v-25814009],.main.btn.facebook[data-v-25814009] .btnText>span{vertical-align:middle;color:var(--color-white);font-weight:600;font-family:EuclidFlex}", ""]);
// Exports
module.exports = exports;
